import getTrackingAdapter from 'src/app/dataAnalytics';
import { sendViewEvent } from 'src/app/utils/analytics';
import { log } from 'src/app/utils/logging';

export const sendPageTracking = (
  page: string,
  isPageAnalyticsEnabled: boolean,
) => {
  log.info('PageViewTracker | sendPageTracking', {
    page,
    isPageAnalyticsEnabled,
  });
  if (isPageAnalyticsEnabled) {
    getTrackingAdapter.sendPageEvent();
  } else {
    sendViewEvent();
  }
};
